const initialState = {
    data: null,
    check: null,
};

const detailBookReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DETAIL_BOOK_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'DETAIL_BOOK_CHECK_SUCCESS':
            return {
                ...state,
                check: action.payload,
            };
        case 'DETAIL_BOOK_FAILURE':
            return state;
        default:
            return state;
    }
};

export default detailBookReducer;
